import { Component, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';


import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { Subject, Subscription, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, mergeMap, map } from 'rxjs/operators';
import { TimeService } from '../time.service';
import { EventService } from '../event.service';


import * as moment from 'moment';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SnackbarService } from '../snackbar.service';
import { SocketService } from '../socket.service';
import { MessagingService } from '../messaging.service';
import { DateTime } from 'luxon';
import { ValidationService } from '../validation.service';
import { MatTable, MatTableDataSource, MatPaginator, MatSort, MatDialog, PageEvent, Sort } from '@angular/material';
import { AssignModalComponent } from '../dashboardModals/assign-modal/assign-modal.component';
import { AcceptModalComponent } from '../dashboardModals/accept-modal/accept-modal.component';

import { Messages } from '../constants/messages';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { TranslateService } from '@ngx-translate/core';




export interface Bid {
  order: string;
  auto: boolean;
  amount: number;
  floor_amount?: number;
  decrement_amount?: number;
  carrier?: string;
  reason?: string;
}

enum bid_status_string {
  in_progress = 'In Progress',
  won = 'Won',
  lost = 'Lost',
  canceled = 'Cancelled',
  closed = 'Closed'
}

export interface Orders {
  _id: string;
  OIN: string;
  pickDate: string;
  from: Array<any>;
  dropDate: string;
  to: Array<any>;
  requested: string;
  accepted: string;
  vehicle: object;
  // organization: object;
  shipper: object;
  costPerVehicle: string;
  // materials: Array<any>;
  // allocation: string;
  status: string;
  // totalShipments: number;
}

@Component({
  selector: 'app-bid-order',
  templateUrl: './bid-order.component.html',
  styleUrls: ['./bid-order.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0.6 }),
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ])
    ]),

  ],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class BidOrderComponent implements OnInit {


  @ViewChild('switchToManualDialog', { static: true }) callAPIDialog: TemplateRef<any>;
  @ViewChild('assignmentTable', { static: true }) assignmentTable: MatTable<any>;

  currency = 'Rs';
  ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'req_no_of_vehicles', 'deadline', 'bid_status', 'costPerVehicle', 'status'];
  ordersArray: any = [];
  totalOrders = 0;
  orders: any = [];
  showStatusTab = 0;
  tabIndex = 0;
  bidType = '';
  showLoader = false;
  selectedOrderData: any;
  selectedOrderAllLocationsData: any;
  showOrderDetailsView = 0;
  shipmentsColumns = ['SIN', 'shipper'];
  lastBidColumns = ['slno', 'datetime', 'bid_amt'];
  bid_status; // status of the bid (in_progress/won/lost)
  auto_bid; // holds the status of the checkbox
  disable_input = false; // disable the inputs when auto bid is on

  orderType = false; // false for normal , true for bids



  shipmentStatusArray: any = [];
  assigned: any = [];
  inTransit: any = [];
  completed: any = [];
  tab = 0;
  min_bid_diff: number; // minimum decrement amount while auto bidding
  max_bid_amount: number; // maximum bid amount i.e lowest bid amount - minimum bid difference


  bidData: Bid = {
    order: '',
    auto: false,
    amount: 0,
  };

  lastBids = {
    last_bid: 0,
    order_lowest: 0,
    bids: []
  };
  selectedStatus: any;//holds the selected status (Available/Deleted)

  statusArray = [
    {
      status: "Active",
      is_deleted: false
    },
    {
      status: "Deleted",
      is_deleted: true
    }
  ];

  currencySymbol;

  // assignment table columns and data source
  assignmentColumns: string[] = ['requested', 'accepted', 'cancelled', 'deadline', 'assigned', 'action'];
  assignmentDataSource = [];


  carrierId: Subscription;

  // Filters
  filterOrder = '';
  filterShipper = '';
  dashboardFilters = {
    // oin: '',
    // shipper_name: '',
    is_deleted: false,
    limit: 0,
    skip: 0
  };

  dialogRef;

  isMobileView = false;

  ordersList: MatTableDataSource<Orders>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  searchTextChanged = new Subject<object>();
  subscription: Subscription;

  messages = new Messages();
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  allow_bid: boolean;
  selectedCarrier: any;
  reqest_sent: boolean;
  unapproved_bid_amount: any;
  approveSuccess: boolean;
  rejectSuccess: boolean;
  reason: any;
  constructor(private dialog: MatDialog, private translation: TranslateService, private changeDetection: ChangeDetectorRef, private http: HttpService,
    private storage: StorageService, private route: Router, private events: EventService,
    public timeService: TimeService, private snackbar: SnackbarService, private socket: SocketService,
    private fcmService: MessagingService, private valid: ValidationService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  ngOnInit() {
    this.selectedStatus = this.statusArray[0];
    this.events.bidUpdateChanges().subscribe(
      (response) => {
        if (this.selectedOrderData && response.OIN == this.selectedOrderData.order) {
          if (this.selectedOrderData.lowest_bid_amount > response.amount) {
            this.selectedOrderData.lowest_bid_amount = response.amount;
            if (this.bidData.auto && response.amount <= this.bidData.floor_amount) {
              this.switchToManual(this.selectedOrderData._id);
            }
            // if(this.bidData.auto && ((response.amount - this.bidData.decrement_amount) < this.bidData.floor_amount )){
            //   console.log('In second condition');
            //   this.switchToManual(this.selectedOrderData._id);
            // }
          }
          this.getOrders();
          this.getLastBids(this.selectedOrderData._id);
        }
        this.getOrders();
      });

    //bid order stopped
    this.events.BidOrderStopped().subscribe(
      (response) => {
        if (this.selectedOrderData && response.OIN == this.selectedOrderData.order) {
          this.getLastBids(this.selectedOrderData._id)
        }
        this.getOrders();
      }
    )
    this.getOrders({});

    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrders({});
        const rupee = JSON.parse(localStorage.getItem('carriers'));
        this.currencySymbol = rupee[0].country.currency.symbol;
      },
      (err: any) => {
        // console.log('Err ::', err);
      }
    );
    this.isMobileView = window.innerWidth <= 480;

    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth <= 480;
    })
  }


  getOrders(filter: any = {}) {
    // filter.type = type;
    this.showLoader = true;

    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    filter.is_deleted = this.selectedStatus.is_deleted;

    this.http.get('bid/orders', filter).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data.orders;
          this.totalOrders = data.data.count;
          this.orders = [];
          this.ordersArray.forEach((element, i) => {
            const temp: any = {};
            temp.isAutoBid = element.auto; // is bid auto?
            temp.assignment_deadline = element.assignment_deadline;
            if (temp.isAutoBid) {
              temp.floor_amount = element.floor_amount;
              temp.decrement_amount = element.decrement_amount;
            }
            temp.bid_status = element.status; // bid_status (in_progress/won/lost/cancelled/closed)
            temp.bid_status_string = bid_status_string[element.status]; // proper value to show in table(In Progress/Won/Lost)
            // order details
            element = element.order;
            if (element) {
              temp._id = element._id;
              temp.accepted = element.accepted;
              temp.rejected = element.rejected;
              temp.bidding_type = element.bidding_type;
              temp.assigned = element.assigned;
              temp.to_be_assigned = element.accepted - (element.assigned + element.cancelled_vehicles);
              temp.created_at = element.created_at;
              temp.bidding_end_date = (element.bidding_end_date) ? this.timeService.toShortDateTime(element.bidding_end_date) : '--';
              temp.readableDeadline = (element.bidding_end_date) ? moment(element.bidding_end_date).fromNow() : 'N/A';
              temp.shipper = element.shipper;
              temp.order = element.OIN;
              temp.is_bidding = element.is_bidding;
              temp.lowest_bid_amount = element.lowest_bid_amount;
              temp.pickDate = this.timeService.toShortDateTime(element.pickup_locations[0].date_time);
              temp.from = element.pickup_locations;
              temp.dropDate = this.timeService.toShortDateTime(element.delivery_locations[0].date_time);
              temp.to = element.delivery_locations;
              temp.vehicle = element.vehicle_type ? element.vehicle_type : 'N/A';
              temp.min_bid_diff = parseInt(element.min_bid_diff); // minimum decrement amount during auto bid
              temp.max_bid_amount = parseInt(element.lowest_bid_amount) - parseInt(element.min_bid_diff); // maximum bid amount i.e lowest bid amount - minimum bid difference
              temp.req_no_of_vehicles = element.req_no_of_vehicles; // requested number of vehicles
              temp.cancelled_vehicles = element.cancelled_vehicles; // requested number of vehicles
              temp.costPerVehicle = (element.allocations.length) ? element.allocations[element.allocations.length - 1].rate_per_km : '';
              temp.status = element.accepted > 0;
              temp.delete_reason = element.delete_reason ? element.delete_reason : '--';
              temp.purchase_order = element.purchase_order || "--";
              temp.segmentation = element.segmentation || "--";
              if (element.payment_term) {
                temp.payment_term = element.payment_term;
              }
              temp.docs = (element.doc_urls && element.doc_urls.length) ? element.doc_urls.map(element => {
                return {
                  extension: element.substr(element.lastIndexOf('.')).substr(1),
                  link: element
                };
              }) : [];
              if (element.weight_based) {
                temp.weight_based = element.weight_based;
                temp.uom = element.uom;
              }
              temp.accessories = element.accessories ? element.accessories : [];
              temp.permits = element.permits ? element.permits : [];
              temp.materials = element.materials ? element.materials : [];
              temp.shipmentWeight = element.per_vehicle_weight;
              temp.bidding = element.is_bidding ? 'Yes' : 'No';
              temp.payment_term = element.payment_term ? element.payment_term : '--';
              temp.comments = element.comments ? element.comments : '--';
              temp.packages = element.no_of_packages ? element.no_of_packages : '--';
              temp.cbm = element.cbm_value ? element.cbm_value : '--';
              if (element.payment_term) {
                temp.payment_term = element.payment_term;
              }
              this.orders.push(temp);
            }

            // temp.bid_status_value = element.bid_status === 'lost' ? "Lost" : (element.bid_status === 'won' ? 'Won' : 'In Progress');
          });
          this.showLoader = false;

          if (!this.ordersList) {
            this.ordersList = new MatTableDataSource(this.orders);
            this.ordersList.sort = this.sort;
            this.ordersList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
          } else {
            this.ordersList = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  selectStatus(status) {
    this.selectedStatus = status;
    if (status.is_deleted) {//is deleted = true add the reason field to the table
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'reason'];
    } else {
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'req_no_of_vehicles', 'deadline', 'bid_status', 'costPerVehicle', 'status'];
    }
    this.paginator.pageIndex = 0;
    this.dashboardFilters.is_deleted = status.is_deleted;
    this.getOrders(this.dashboardFilters);
  }

  pageNavigate(event: PageEvent) {
    this.dashboardFilters.limit = event.pageSize;
    this.dashboardFilters.skip = event.pageIndex * event.pageSize;
    this.dashboardFilters.is_deleted = this.selectedStatus.is_deleted;
    this.getOrders(this.dashboardFilters);
  }

  sortOrderData(sort: Sort) { // TODO:
    const dataToFilter = this.ordersList.filteredData.slice();

    if (!sort.active || sort.direction === '') {
      this.ordersList = new MatTableDataSource(this.orders.slice());
      this.ordersList.sort = this.sort;
      return;
    }

    const filtered = dataToFilter.sort((item1: any, item2: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'order': return this.compare(item1.order, item2.order, isAsc);
        case 'pickDate': return this.timeService.compareDate(item1.pickDate, item2.pickDate, isAsc);
        case 'from': {
          let a: string, b: string;
          (item1.from[0].loc_id.name) ? a = item1.from[0].loc_id.name : a = item1.from[0].loc_id.city;
          (item2.from[0].loc_id.name) ? b = item2.from[0].loc_id.name : b = item2.from[0].loc_id.city;
          return this.compare(a, b, isAsc);
        }
        case 'to': {
          let a: string, b: string;
          (item1.to[0].loc_id.name) ? a = item1.to[0].loc_id.name : a = item1.to[0].loc_id.city;
          (item2.to[0].loc_id.name) ? b = item2.to[0].loc_id.name : b = item2.to[0].loc_id.city;
          return this.compare(a, b, isAsc);
        }
        case 'vehicle': return this.compare(item1.vehicle, item2.vehicle, isAsc);
        case 'allocation': return this.compare(item1.allocation, item2.allocation, isAsc);
        case 'materials': return this.compare(item1.materials[0].name, item2.materials[0].name, isAsc);
        case 'organization': return this.compare(item1.organization.name, item2.organization.name, isAsc);
        case 'status': return this.compare(item1.status, item2.status, isAsc);
        default: return 0;
      }
    });
    this.ordersList = new MatTableDataSource(filtered);
    this.ordersList.sort = this.sort;
    return;
  }

  compare(item1: number | string, item2: number | string, isAsc: boolean) {
    return (item1 < item2 ? -1 : 1) * (isAsc ? 1 : -1);
  }

  openAssignModal(data) {
    data = {
      order_id: data._id,
      order: this.selectedOrderData,
      assign_number: (data.accepted - data.cancelled_vehicles - data.assigned)
    };
    const dialogRef = this.dialog.open(AssignModalComponent, {
      data: data,
      width: "1250px",
      maxWidth: "95vw !important",
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getOrders();
      this.getLastBids(this.selectedOrderData._id);

    });
  }



  changeDateFormat(date) {
    return this.timeService.toShortDateMonth(date) + ' | ' + this.timeService.formatDate(date);
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getOrders(x);
    });
    this.changeDetection.detectChanges();
  }

  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (value.length >= 3) {
      // switch (type) {
      //   case 'order':
      //     this.dashboardFilters.oin = value;
      //     break;
      //   case 'shipper':
      //     this.dashboardFilters.shipper_name = value;
      //     break;
      // }
      this.reSubscribe();
      this.searchTextChanged.next(this.dashboardFilters);
    }
  }


  showOrderDetails(element) {
    this.selectedOrderData = element;
    this.selectedOrderAllLocationsData = element.from.concat(element.to);
    this.showStatusTab = 1;
    this.showOrderDetailsView = 1;
  }

  getShipmentStatus() {
    this.shipmentStatusArray = [];
    this.http.get('shipment/by_order?order_id=' + this.selectedOrderData._id).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.length) {
            const allShipments: any = data.data;
            allShipments.forEach(element => {
              if (element.status == 'ASN') {
                this.assigned = element.shipments;
                this.shipmentStatusArray = this.assigned;
              } else if (element.status == 'CPTD') {
                this.completed = element.shipments;
              } else {
                this.inTransit = element.shipments;
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  changeTab() {
    if (this.tab == 0) {
      this.shipmentStatusArray = this.assigned;
    }
    if (this.tab == 1) {
      this.shipmentStatusArray = this.inTransit;
    }
    if (this.tab == 2) {
      this.shipmentStatusArray = this.completed;
    }
  }

  // place a bid
  bid() {
  let valid = true;
  if (this.bidData.amount === this.max_bid_amount && this.bidType !== 'rfq') {
    valid = false;
    this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.EQUAL_AMOUNT, '', 'err');
  }
  else{
    if (!this.bidData.auto) {//auto bid set to false
      if (this.bidData.amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.AMOUNT, '', 'err');
      }
      if (this.bidData.amount > 1 && !this.valid.isNumber(this.bidData.amount)) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_AMT, '', 'err');
      }
    } else {//auto bid is set to true
      if (!this.bidData.amount || this.bidData.amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.AMOUNT, '', 'err');
      }
      if (this.bidData.amount > 1) {
        if (!this.valid.isNumber(this.bidData.amount)) {
          valid = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_AMT, '', 'err');
        }
      }
      if (!this.bidData.floor_amount || this.bidData.floor_amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.FLOOR_AMOUNT, '', 'err');
      }
      if (this.bidData.floor_amount > 1) {
        if (!this.valid.isNumber(this.bidData.floor_amount)) {
          valid = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_FLOOR_AMT, '', 'err');
        }
      }
      if (Number(this.bidData.floor_amount) > Number(this.bidData.amount)) {//floor amount should be less than the bid amount
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.FLOOR_AMOUNT_GREATER, '', 'err');
      }
      if (!this.bidData.decrement_amount || this.bidData.decrement_amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.DECREMENT_VALUE, '', 'err');
      }
      if (this.bidData.decrement_amount > 1) {
        if (!this.valid.isNumber(this.bidData.decrement_amount)) {
          valid = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_DECREMENT_AMT, '', 'err');
        }
        }
      }
    }


    if (valid) {
      delete this.bidData.carrier;
      delete this.bidData.reason;
      this.http.post('order/bid', this.bidData).subscribe(
        (response: any) => {
          if (response.statusCode == 200) {
            this.snackbar.openSnackBar(this.messages.BID_ORDERS.SUCCESS.BID);
            this.bidData.amount = 0;
            this.getLastBids(this.selectedOrderData._id)
          }
        },
        (err) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 420) {
            // this.showManualDialog();
          }
        }
      );
    }
  }

  bidRequest() {
    let valid = true;

    if (this.bidData.amount < 1) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.AMOUNT, '', 'err');
    }
    if (this.bidData.amount > 1 && !this.valid.isNumber(this.bidData.amount)) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_AMT, '', 'err');
    }

    if (!this.reason) {
      this.snackbar.openSnackBar('Reason is required', '', 'err');
    }
    
    this.bidData.carrier = this.selectedCarrier;
    this.bidData.reason = this.reason;

    delete this.bidData.auto;
       
    if (valid) {
      this.http.post('order/bid_request', this.bidData).subscribe(
        (response: any) => {
          if (response.statusCode == 200) {
            this.disable_input = true;
            this.snackbar.openSnackBar(this.messages.BID_ORDERS.SUCCESS.REQUEST);
            this.getLastBids(this.selectedOrderData._id)
          }
        },
        (err) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 420) {
            // this.showManualDialog();
          }
        }
      );
    }

    this.bidData.carrier = null;
    this.reason = null;

  }

  // show dialog suggesting to change from auto bid to manual bid
  showManualDialog(event) {
    if (!event.checked && this.auto_bid) {
      this.dialogRef = this.dialog.open(this.callAPIDialog);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          if (result === 'yes' && this.auto_bid) {
            this.switchToManual(this.selectedOrderData._id);
          } else if (result === 'no') {
            this.bidData.auto = true; // keep the checkbox enabled when clciked on 'No'
            this.closeModal('no');
          }
        } else {
          this.bidData.auto = true;
        }
      });
    } else {
      this.bidData.decrement_amount = undefined;
      this.bidData.floor_amount = undefined;
    }
  }

  closeModal(data) {
    this.dialogRef.close(data);
  }

  switchToManual(orderId) {
    if (orderId) {
      this.http.post('bid/disable_autobid', { order: orderId }).subscribe(
        (response: any) => {
          if (response.statusCode == 200) {
            this.bidData.auto = false;
            this.selectedOrderData.isAutoBid = this.bidData.auto;
            this.disable_input = this.bidData.auto;
            this.auto_bid = false;
            this.bidData.decrement_amount = undefined;
            this.bidData.floor_amount = undefined;
            this.snackbar.openSnackBar(this.messages.BID_ORDERS.SUCCESS.SWITCH, '');
          }
        }
      );
    }
  }

  openAssignSideModal(element) {
    this.showStatusTab = 1;
    this.showOrderDetailsView = 0;
    this.selectedOrderData = element;
    this.bidData.order = element._id;
    this.disable_input = element.isAutoBid;

    // bid data if bid was autobid
    this.bidData.auto = element.isAutoBid; // flag for autobid
    this.bidData.decrement_amount = element.decrement_amount; // decrement amount
    this.bidData.floor_amount = element.floor_amount; // Floor amount
    this.getLastBids(element._id);
  }

  // get assignment details of the order
  getAssignmentDetails(element) {
    // assignment data after bid is placed
    this.assignmentDataSource = [];
    if (element.bid_status === 'won') {// if bid is won
      this.bid_status = element.bid_status;
      const now: any = DateTime.local();
      const deadline: any = this.timeService.IsoToUTC(element.assignment_deadline);
      this.assignmentDataSource.push({
        requested: element.req_no_of_vehicles,
        accepted: element.accepted,
        cancelled_vehicles: element.cancelled_vehicles,
        assignmentDeadline: (element.assignment_deadline) ? this.timeService.toShortDateMonthTime(element.assignment_deadline) : '--',
        disableAssign: (element.assignment_deadline) ? (deadline.ts > now.ts) ? true : false : false,
        to_be_assigned: element.accepted - (element.assigned + element.cancelled_vehicles),
        assigned: element.assigned,
        _id: element._id
      });
    } else {// bid is lost or in-progress
      this.bid_status = element.bid_status;
    }
  }


  clearBids() {
    this.lastBids = {
      last_bid: 0,
      order_lowest: 0,
      bids: []
    };
  }

  getLastBids(id) {
    this.clearBids();
    this.http.get('order/bids?order=' + id).subscribe(
      (response: any) => {
        this.bidType = response.data.order.bidding_flow;
        this.lastBids.bids = [];
        this.lastBids.last_bid = 0;
        this.bidData.auto = response.data.auto;
        this.lastBids.last_bid = (response.data.lowest_bid_amount);
        this.lastBids.order_lowest = (response.data.order.lowest_bid_amount);
        this.selectedCarrier = response.data.carrier;
        this.reqest_sent = response.data.email_requested;
        this.allow_bid = response.data.approve_by_shipper;
        this.unapproved_bid_amount = response.data.unapproved_bid_amount;

        const aggregatedBids = response.data.bids.reduce((acc, bid) => {
            const key = `${bid.amount}-${bid.ts}`; 
            if (!acc[key]) {
                acc[key] = { ...bid, count: 1 };
            } else {
                acc[key].count += 1; 
            }
            return acc;
        }, {});

        this.lastBids.bids = Object.values(aggregatedBids).map((element: any, i) => {
          return {
            slno: i + 1,
            datetime: this.timeService.formatDate(element.ts, 'hh:mm a'),
            bid_amt: (element.amount)
          };
        }); 
        // this.lastBids.bids = response.data.bids.map((element, i) => {
        //   return {
        //     slno: i + 1,
        //     datetime: this.timeService.formatDate(element.ts, 'hh:mm a'),
        //     bid_amt: (element.amount)
        //   };
        // });
        this.lastBids.bids.reverse();

        if (this.bidType === 'rfq' && this.lastBids.bids.length > 0) {
          const lastBidAmount = this.lastBids.bids[this.lastBids.bids.length - this.lastBids.bids.length].bid_amt;
         
          if (this.unapproved_bid_amount != lastBidAmount ) {
              this.rejectSuccess = true;
          }

          else if (this.unapproved_bid_amount == lastBidAmount && lastBidAmount == this.lastBids.last_bid) {
            this.rejectSuccess = false;
          }

          if(this.bidType === 'rfq' && lastBidAmount == this.lastBids.last_bid) {
            this.approveSuccess = true;
          }
        }


        this.min_bid_diff = parseInt(response.data.order.min_bid_diff);// minimum decrement amount
        this.max_bid_amount = ((parseInt(response.data.order.lowest_bid_amount) - this.min_bid_diff) > 0) ? (parseInt(response.data.order.lowest_bid_amount) - this.min_bid_diff) : 0;// maximum bid amount i.e lowest bid amount - minimum bid difference
        this.disable_input = response.data.auto;
        this.auto_bid = response.data.auto;
        this.bidData.amount = this.max_bid_amount - 1;
        if(this.bidType == 'rfq'){
          this.bidData.amount =  this.lastBids.last_bid;
        }
        if(this.reqest_sent && !this.allow_bid && this.bidType === 'rfq' || (this.bidType === 'rfq' && this.unapproved_bid_amount != undefined)){
          this.bidData.amount = this.unapproved_bid_amount;
        }

        this.selectedOrderData.bidding_type = response.data.order.bidding_type;
        if (this.selectedOrderData.weight_based) {
          this.selectedOrderData.weight_based = response.data.order.weight_based;
        }


        const element = {
          bid_status: response.data.status,
          bidding_type: response.data.order.bidding_type,
          assignment_deadline: response.data.assignment_deadline,
          req_no_of_vehicles: response.data.order.req_no_of_vehicles,
          cancelled_vehicles: response.data.order.cancelled_vehicles,
          accepted: response.data.order.accepted,
          assigned: response.data.order.assigned,
          to_be_assigned: response.data.order.accepted - (response.data.order.assigned + response.data.order.cancelled_vehicles),
          _id: response.data.order._id
        };
        this.getAssignmentDetails(element);

      },
      (err) => {
        // this.snackbar.openSnackBar(err.message, '', 'err')
      }
    );
  }
  openOrderDetails(element) {
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      data: element
    });
  }

}
